<template>
  <div class="coupon">
    <div class="page-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('common.finance') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('financial.breadcrumb.couponDetail') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page-section">
      <el-form class="page-search__form" ref="searchForm" :model="listInfo">
        <div style="width: 100%; display: flex; align-items: center">
          <div class="page-search__item page-search__item_large">
            <el-form-item>
              <el-date-picker
                :clearable="false"
                v-model="listInfo.date"
                unlink-panels
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('common.to')"
                :start-placeholder="$t('common.dateStart')"
                :end-placeholder="$t('common.dateEnd')"
                :picker-options="pickerOptions"
                @change="handleDateChange"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div class="page-search__item">
            <div class="coupon-search__btns">
              <span
                class="coupon-search__btns-today"
                :class="activeDateBtn === 0 ? 'active' : ''"
                @click="searchByDate(0)"
                >{{ $t('common.today') }}</span
              >
              |
              <span>{{ $t('common.recentPrefix') }}</span>
              <span
                class="coupon-search__btns-month"
                :class="activeDateBtn === 30 ? 'active' : ''"
                @click="searchByDate(30)"
                >{{ $t('common.oneMonth') }}</span
              >
              <!-- <span
                class="coupon-search__btns-month"
                :class="activeDateBtn === 90 ? 'active' : ''"
                @click="searchByDate(90)"
                >3个月</span
              >
              <span
                class="coupon-search__btns-month"
                :class="activeDateBtn === 180 ? 'active' : ''"
                @click="searchByDate(180)"
                >6个月</span
              > -->
            </div>
          </div>
          <div class="page-search__item">
            <el-form-item>
              <el-select
                :placeholder="$t('common.visaRegion')"
                clearable
                filterable
                v-model="listInfo.countryIds"
                multiple
                collapse-tags
                @remove-tag="removeTag"
                @change="handleCountryChange"
              >
                <el-option
                  :label="$t('common.selectAll')" value="全选"
                  @click.native="selectAll"
                ></el-option>
                <el-option
                  @click="handleSelectCountry(item)"
                  v-for="item in countryDict"
                  :key="item.countryId"
                  :label="item.name"
                  :value="item.countryId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="page-search__item">
            <el-form-item label prop="typeIds">
              <el-select
                :placeholder="$t('common.visaType')"
                clearable
                filterable
                v-model="listInfo.typeIds"
                multiple
                collapse-tags
                @remove-tag="removeTypeTag"
                :disabled="listInfo.countryIds.length != 1"
              >
                <el-option
                  :label="$t('common.selectAll')" value="全选"
                  @click.native="selectTypeAll"
                ></el-option>
                <el-option
                  v-for="item in visaTypeDict"
                  :key="item.typeId"
                  :label="item.type"
                  :value="item.typeId"
                ></el-option>
              </el-select>
              <!-- <el-select
              :placeholder="$t('common.visaType')"
              clearable
              filterable
              v-model="listInfo.typeId"
              :disabled="listInfo.countryIds.length != 1"
            >
              <el-option :label="$t('common.all')" :value="null"></el-option>
              <el-option
                v-for="item in visaTypeDict"
                :key="item.typeId"
                :label="item.type"
                :value="item.typeId"
              ></el-option>
            </el-select> -->
            </el-form-item>
          </div>
        </div>
        <div class="page-search__item">
          <el-form-item>
            <el-input v-model="listInfo.passportNum" :placeholder="$t('common.passportNo')"></el-input>
          </el-form-item>
        </div>

        <div class="page-search__item">
          <el-form-item>
            <el-select
              :placeholder="$t('common.operator')"
              clearable
              filterable
              v-model="listInfo.operatorIds"
              multiple
              collapse-tags
              @remove-tag="removeOperatorTag"
            >
              <el-option
                :label="$t('common.selectAll')"
                value="全选"
                @click.native="selectOperatorAll"
              ></el-option>
              <el-option
                v-for="item in operatorDict"
                :key="item.id"
                :label="item.realName"
                :value="item.id"
              ></el-option>
            </el-select>

            <!-- <el-select
              :placeholder="$t('common.operator')"
              clearable
              filterable
              v-model="listInfo.operatorId"
            >
              <el-option :label="$t('common.all')" :value="null"></el-option>
              <el-option
                v-for="item in operatorDict"
                :key="item.id"
                :label="item.realName"
                :value="item.id"
              ></el-option>
            </el-select> -->
          </el-form-item>
        </div>
        <div class="page-search__item">
          <el-form-item>
            <el-select :placeholder="$t('common.category')" clearable filterable v-model="listInfo.type">
              <el-option :label="$t('common.all')" :value="null"></el-option>
              <el-option
                v-for="item in couponTypeDict"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="page-search__item">
          <el-form-item>
            <el-input v-model="listInfo.remarks" :placeholder="$t('common.remark')"></el-input>
          </el-form-item>
        </div>
        <div class="page-search__btns">
          <div class="page-search__btns-left">
            <el-button
              type="primary"
              class="page-button_medium page-button_blue"
              :loading="downloadLoading"
              @click="download"
              >{{ $t('common.exportExcel') }}</el-button
            >
            <span class="coupon-data"
              >{{ $t('financial.coupon.summaryConsume', { n: $options.filters.filterToYuan(expenditure) }) }} {{ $t('financial.coupon.summarySeparator') }} {{ $t('financial.coupon.summaryRecharge', { n: $options.filters.filterToYuan(income) }) }}</span
            >
          </div>
          <div class="page-search__btns-right">
            <div style="text-align: right">
              <el-button
                type="primary"
                class="page-button_medium"
                @click="getCouponData()"
                >{{ $t('common.search') }}</el-button
              >
              <el-button @click="resetSearch">{{ $t('common.reset') }}</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="page-section">
      <div class="page-table" v-if="tableHeight > 0">
        <el-table
          :data="listData"
          :max-height="tableHeight + 'px'"
          v-loading="listLoading"
          :element-loading-text="$t('common.loading')"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column :label="$t('common.category')" prop="title" min-width="120px"></el-table-column>
          <el-table-column
            :label="$t('common.time')" prop="gmtCreate"
            min-width="180px"
          ></el-table-column>
          <el-table-column
            :label="$t('common.operator')" prop="realName"
            min-width="140px"
          ></el-table-column>
          <el-table-column :label="$t('common.countryVisaType')" min-width="120px">
            <template slot-scope="{ row }">
              {{ row.countryOne || row.countryTwo || row.countryThree || "--" }}
              <br />
              {{ row.typeOne || row.typeTwo || "--" }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.namePassport')" min-width="160px">
            <template slot-scope="{ row }">
              {{ row.nameOne || row.nameTwo || "--" }}
              <br />
              {{ row.passportNumOne || row.passportNumTwo || "--" }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.couponChange')" min-width="140px">
            <template slot-scope="{ row }">
              <span :class="{ active: row.score > 0 }">{{
                row.score | filterToYuan
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('common.couponBalance')"
            prop="scoreBalance"
            :formatter="formatToYuan"
            min-width="140px"
          ></el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('common.remark')" prop="remarks"
            min-width="140px"
          ></el-table-column>
        </el-table>
      </div>
      <div class="page-pagination">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="getCouponData"
          :current-page="listInfo.pageNum"
          :page-size="listInfo.pageSize"
          :total="listInfo.totalCount"
        ></el-pagination>
      </div>
      <el-dialog :visible.sync="fileDialog" width="500px">
        <div>{{ $t('common.exportProcessing') }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="button-medium"
            style="padding: 7px 30px; font-size: 12px"
            @click="fileDialog = false"
            type="info"
            >{{ $t('common.close') }}</el-button
          >
          <el-button
            class="button-medium"
            style="padding: 0px 30px; font-size: 12px"
            type="primary"
            @click="goDownload"
            >{{ $t('common.confirm') }}</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment, { months } from "moment";
import * as toolApi from "@/apis/tool";
import * as financialApi from "@/apis/financial";
import { formatToYuan } from "@/utils/formatters";
import { getBaseURL } from "@/utils/util";
import { getCookie } from "@/utils/util";
import { mapActions, mapGetters } from "vuex";
import { getWebURL, getPageURL, getLocationSearch } from "@/utils/util";
export default {
  name: "coupon",
  data() {
    return {
      fileDialog: false,
      tableHeight: 0,
      formatToYuan,
      countryDict: [],
      operatorDict: [],
      visaTypeDict: [],
      couponTypeDict: [],
      listData: [],
      listInfo: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        remarks: "",
        passportNum: "",
        date: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
        dateFrom: moment().subtract(30, "d").format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        operatorIds: [],
        orderBy: "",
        type: "",
        typeIds: [],
        username: "",
        countryIds: [],
      },
      income: 0,
      expenditure: 0,
      listLoading: false,
      activeDateBtn: "",
      downloadLoading: false,
      pickerMinDate: "",
      choiceDate0: "",
      // pickerOptions: {
      //   onPick: ({ maxDate, minDate }) => {
      //     this.choiceDate0 = minDate.getTime();
      //     if (maxDate) {
      //       this.choiceDate0 = "";
      //     }
      //   },
      //   disabledDate: (time) => {
      //     let choiceDateTime = new Date(this.choiceDate0).getTime();
      //     const minTime = new Date(choiceDateTime).setMonth(
      //       new Date(choiceDateTime).getYear() - 1
      //     );
      //     const maxTime = new Date(choiceDateTime).setMonth(
      //       new Date(choiceDateTime).getYear() + 1
      //     );
      //     const min = minTime;
      //     const newDate =
      //       new Date(new Date().toLocaleDateString()).getTime() +
      //       24 * 60 * 60 * 12 * 1000 -
      //       1;
      //     const max = newDate < maxTime ? newDate : maxTime;
      //     //如果已经选中一个日期 则 返回 该日期前后一个月时间可选
      //     if (this.choiceDate0) {
      //       return time.getTime() < min || time.getTime() > max;
      //     }
      //     //若一个日期也没选中 则 返回 当前日期以前日期可选
      //     return time.getTime() > newDate;
      //   },
      // },
      // pickerOptions: {
      //   onPick: ({ maxDate, minDate }) => {
      //     this.selectDate = minDate.getTime();
      //     if (maxDate) {
      //       this.selectDate = "";
      //     }
      //   },
      //   disabledDate: (time) => {
      //     // time.getTime()获取的是时间戳
      //     // 只能选择365天的范围且不能大于当前日期
      //     const choiceDateTime = new Date(this.selectDate).getTime();
      //     const minTime = new Date(choiceDateTime).setMonth(
      //       new Date(choiceDateTime).getMonth() - 12
      //     );
      //     const maxTime = new Date(choiceDateTime).setMonth(
      //       new Date(choiceDateTime).getMonth() + 12
      //     );
      //     const min = minTime;
      //     const newDate =
      //       new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
      //     const max = newDate < maxTime ? newDate : maxTime;
      //     // 如果已经选中一个日期 则 返回 该日期前后12个月时间可选,后12个月最大为当前日期
      //     if (this.selectDate) {
      //       return time.getTime() < min || time.getTime() > max;
      //     }
      //     // 若一个日期也没选中 则 返回 当前日期以前日期可选
      //     return time.getTime() > newDate;
      //   },
      // },
      baseDate: null, // 记录第一次选中的日期
      pickerOptions: {
        disabledDate: (time) => {
          const today = new Date();
          // 禁止未来日期
          if (time.getTime() > today.getTime()) return true;

          // 如果已经选择了开始日期，则限制区间
          if (this.baseDate) {
            const min = new Date(this.baseDate);
            min.setMonth(min.getMonth() - 6);

            const max = new Date(this.baseDate);
            max.setMonth(max.getMonth() + 6);

            return time.getTime() < min.getTime() || time.getTime() > max.getTime();
          }

          return false;
        },
        onPick: ({ minDate, maxDate }) => {
          // 只选了开始日期
          if (minDate && !maxDate) {
            this.baseDate = minDate;
          }
          // 选完区间后清空基准日期
          if (minDate && maxDate) {
            this.baseDate = null;
          }
        },
      },
    };
  },
  computed: {
    ...mapGetters(["downloadNum"]),
  },
  mounted() {
    this.tableHeight = window.innerHeight - 366;
    this.getCountryDict();
    this.getOperatorDict();
    this.getCouponTypeDict();
    this.getCouponData();
    console.log(this.downloadNum, "downloadNum");
  },

  methods: {
    ...mapActions(["setDownloadNum"]),

    //签证国家全选
    selectAll() {
      if (this.listInfo.countryIds.length < this.countryDict.length) {
        this.countryDict.map((item) => {
          this.listInfo.countryIds.push(item.countryId);
        });
        this.listInfo.countryIds.unshift("全选");
      } else {
        this.listInfo.countryIds = [];
      }
    },
    removeTag(val) {
      if (val === "全选") {
        this.listInfo.countryIds = [];
      }
    },
    handleCountryChange(val) {
      console.log(val, "val");
      this.listInfo.typeIds = [];

      if (!val.includes("全选") && val.length === this.countryDict.length) {
        this.listInfo.countryIds.unshift("全选");
      } else if (val.includes("全选") && val.length - 1 < this.countryDict.length) {
        this.listInfo.countryIds = this.listInfo.countryIds.filter((item) => {
          return item !== "全选";
        });
        console.log(this.listInfo.countryIds, "this.listInfo.countryIds");
      }
      if (this.listInfo.countryIds.length == 1) {
        this.getVisaTypeDict(val[0]);
      } else {
        this.visaTypeDict = [];
      }
    },
    handleSelectCountry(item) {
      this.listInfo.typeIds = [];
      console.log(this.listInfo.countryIds.length, "this.listInfo.countryIds.length");
    },

    //签证类型全选
    selectTypeAll() {
      if (this.listInfo.typeIds.length < this.visaTypeDict.length) {
        this.visaTypeDict.map((item) => {
          this.listInfo.typeIds.push(item.typeId);
        });
        this.listInfo.visaTypeDict.unshift("全选");
      } else {
        this.listInfo.typeIds = [];
      }
    },
    removeTypeTag(val) {
      if (val === "全选") {
        this.listInfo.visaTypeDict = [];
      }
    },

    //签证类型全选
    selectOperatorAll() {
      if (this.listInfo.operatorIds.length < this.operatorDict.length) {
        this.operatorDict.map((item) => {
          this.listInfo.operatorIds.push(item.id);
        });
        this.listInfo.operatorDict.unshift("全选");
      } else {
        this.listInfo.operatorIds = [];
      }
    },
    removeOperatorTag(val) {
      if (val === "全选") {
        this.listInfo.operatorIds = [];
      }
    },

    async getDownloadList() {
      try {
        const result = await toolApi.listDownloadList({
          pageNum: 1,
          pageSize: 100,
        });
        if (result.records && result.records.length > 0) {
          let count = 0;
          result.records.forEach((item) => {
            if (item.status == "DOING") {
              count = count + 1;
            }
            if (item.status == "SUCCESS" && item.downloadStatus == 0) {
              count = count + 1;
            }
          });
          setTimeout(() => {
            this.setDownloadNum(count);
          }, 100);
        }
      } catch (e) {
        console.log(e, "e");
      }
    },
    goDownload() {
      this.fileDialog = false;
      window.open(getWebURL("visa") + "/downloadPage");
      // location.href = getWebURL("visa") + "/downloadPage";
    },
    formatDate(datetime, type) {
      const time = new Date(datetime);
      const year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, "0");
      const date = time.getDate().toString().padStart(2, "0");
      return type === "start"
        ? year + "-" + month + "-" + date + " " + "00" + ":" + "00" + ":" + "00"
        : year + "-" + month + "-" + date + " " + "23" + ":" + "59" + ":" + "59";
    },
    async getCountryDict() {
      const result = await toolApi.getCountryDict();
      if (result) {
        this.countryDict = result;
      }
    },
    async getVisaTypeDict(countryId) {
      const params = {
        countryId,
      };
      const result = await toolApi.getVisaTypeDict(params);
      this.visaTypeDict = result || [];
    },
    async getOperatorDict() {
      const params = {
        pageNum: 1,
        pageSize: 1000,
      };
      const result = await toolApi.getOperatorDict(params);
      if (result) {
        this.operatorDict = result.records || [];
      }
    },
    async getCouponTypeDict() {
      const result = await toolApi.getCouponTypeDict();
      if (result) {
        this.couponTypeDict = result;
      }
    },

    handleDateChange(value) {
      if (value && value[0] && value[1]) {
        this.listInfo.dateFrom = value[0];
        this.listInfo.dateTo = value[1];
      } else {
        // this.pickerMinDate = "";
        this.listInfo.dateFrom = "";
        this.listInfo.dateTo = "";
      }
    },
    async getCouponData(pageNum = 1) {
      this.listLoading = true;
      try {
        this.listInfo.pageNum = pageNum;
        let filterPararms = _.cloneDeep(this.listInfo);
        filterPararms.countryIds = filterPararms.countryIds.filter((item) => {
          return item != "全选";
        });
        filterPararms.typeIds = filterPararms.typeIds.filter((item) => {
          return item != "全选";
        });
        filterPararms.operatorIds = filterPararms.operatorIds.filter((item) => {
          return item != "全选";
        });
        const result = await financialApi.getCouponData(filterPararms);
        this.listLoading = false;

        if (result) {
          const {
            pageInfo: { records, pageNum, totalCount },
            expenditure,
            income,
          } = result;
          this.listData = records || [];
          this.listInfo = {
            ...this.listInfo,
            pageNum,
            totalCount,
          };
          this.expenditure = expenditure;
          this.income = income;
        }
      } catch (err) {
        this.listLoading = false;
        throw new Error(err);
      }
    },
    resetSearch() {
      const startDate = moment().subtract(30, "d").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");

      this.listInfo = {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        countryIds: [],
        date: [startDate, endDate],
        dateFrom: startDate,
        dateTo: endDate,
        operatorIds: [],
        orderBy: "",
        passportNum: "",
        type: "",
        typeIds: [],
        username: "",
      };
      this.activeDateBtn = "";
      this.$refs.searchForm.clearValidate();
      this.getCouponData();
    },
    searchByDate(days) {
      const startDate = moment().subtract(days, "d").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");
      this.listInfo = {
        ...this.listInfo,
        dateFrom: startDate,
        dateTo: endDate,
        date: [startDate, endDate],
      };
      this.activeDateBtn = days;
      this.getCouponData();
    },
    async download() {
      console.log(this.listInfo, "list");
      if (!this.listInfo.date || this.listInfo.date.length == 0) {
        return this.$message.error(this.$t('common.selectDate'));
      }
      this.downloadLoading = true;
      try {
        let filterPararms = _.cloneDeep(this.listInfo);
        filterPararms.countryIds = filterPararms.countryIds.filter((item) => {
          return item != "全选";
        });
        filterPararms.typeIds = filterPararms.typeIds.filter((item) => {
          return item != "全选";
        });
        filterPararms.operatorIds = filterPararms.operatorIds.filter((item) => {
          return item != "全选";
        });
        const result = await financialApi.downloadCouponData(filterPararms);
        this.downloadLoading = false;
        if (result) {
          this.fileDialog = true;
          this.getDownloadList();
          // window.open(getBaseURL("api") + result);
        }
      } catch (err) {
        this.downloadLoading = false;
        throw new Error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.coupon {
  &-data {
    color: $color-black-54;
    padding-left: 16px;
  }
  &-search__btns {
    color: $color-black-54;
    margin-bottom: 16px;
    &-today {
      cursor: pointer;
      &.active,
      &:hover {
        color: $color-green-dark;
      }
    }
    &-month {
      cursor: pointer;
      margin-right: 8px;
      &.active,
      &:hover {
        color: $color-green-dark;
      }
    }
  }
}
</style>
